import React from "react";
import { useStockControlStore } from "../../hooks/useStockControlStore";
import CustomButtonsFormulario from "./CustomButtonsFormulario";

const BotonesControlStock = () => {
  const { openCancelarDialog, openProximoDialog, openFinalizarDialog, stockReal, setMsgError, articulosControlados } = useStockControlStore();

  const handleProximo = () => {
    if (stockReal === null || isNaN(stockReal)) {
      setMsgError("Debés ingresar el stock real.");
      return;
    }

    openProximoDialog();
  };

  return (
    <CustomButtonsFormulario
      mode="custom"
      variant="custom"
      onCancelar={openCancelarDialog}
      onProximo={handleProximo}
      onFinalizar={openFinalizarDialog}
      extraData={articulosControlados}
      customColors={{
        cancelar: "#5A5A5A",
        proximo: "#4600DD",
        finalizar: "#4600DD",
      }}
    />
  );
};

export default BotonesControlStock;
